import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { reflection, background } from './sierras.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220704/sierras-le_sas/sierras-le_sas_{nnn}.png',
}

export default {
  layers: [background, body, reflection],
  resolveOptions: () => ({
    reflections: 'none',
  }),
}
